"use client";
import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/Elecinstallation.css";

import Header from './Header';
import Footer from './Footer';
import Beams from "./Beams"; 

import image1 from "../assets/testing11A.png";
import image2 from "../assets/testing13A.jpeg";
import image3 from "../assets/testing14A.jpeg";
import image4 from "../assets/manpower13A.jpeg";
import image5 from "../assets/manpower1A.jpg";
import image6 from "../assets/manpower12A.jpeg";
import image7 from "../assets/testing15A.jpeg";
import image8 from "../assets/IMG_0742.jpg";

const ElecDesignHeroSection = ({ data }) => {
  const timelineRef = useRef(null);
  const containerRef = useRef(null);
  const [timelineHeight, setTimelineHeight] = useState(0);


  
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const calculateAndUpdateTimelineHeight = () => {
      if (timelineRef.current) {
        const newHeight = timelineRef.current.getBoundingClientRect().height;
        setTimelineHeight(prevHeight => {
          if (newHeight > 0 && (newHeight !== prevHeight || prevHeight === 0)) {
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    const handleLayoutReady = () => {
      calculateAndUpdateTimelineHeight();
      AOS.refresh();
    };

    const initialCalcTimer = setTimeout(calculateAndUpdateTimelineHeight, 50);

    if (document.readyState === "complete") {
      const readyTimer = setTimeout(handleLayoutReady, 100);
      return () => clearTimeout(readyTimer);
    } else {
      window.addEventListener("load", handleLayoutReady);
    }

    window.addEventListener("resize", handleLayoutReady);

    return () => {
      clearTimeout(initialCalcTimer);
      window.removeEventListener("load", handleLayoutReady);
      window.removeEventListener("resize", handleLayoutReady);
    };
  }, [data]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(
    scrollYProgress,
    [0, 1],
    [0, timelineHeight]
  );
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div className="elec-design-hero-container testing-container" ref={containerRef}>
      <div className="elec-design-hero-header">
        <h2 className="elec-design-hero-title">Testing & Commissioning</h2>
        <p className="elec-design-hero-description">
          We ensure every electrical system is rigorously tested and commissioned to meet safety, performance, and compliance standards
        </p>
      </div>

      <div ref={timelineRef} className="elec-design-hero-timeline">
        {data.map((item, index) => (
          <div key={index} className="elec-design-hero-step">
            <div className="elec-design-hero-sticky">
              <div className="elec-design-hero-marker-outer">
                <div className="elec-design-hero-marker-inner" />
              </div>
              <h3 className="elec-design-hero-step-title-desktop">{item.title}</h3>
            </div>

            <div className="elec-design-hero-step-content">
              <h3 className="elec-design-hero-step-title-mobile">{item.title}</h3>
              <img
                src={item.image}
                alt={item.title}
                className="elec-design-hero-step-image"
                data-aos="fade-left"
              />
              <div className="elec-design-hero-step-paragraph" data-aos="fade-left">
                {typeof item.paragraph === "string" ? (
                  <p>{item.paragraph}</p>
                ) : (
                  <>
                    <p>{item.paragraph?.text}</p>
                    {Array.isArray(item.paragraph?.points) &&
                      item.paragraph.points.map((point, idx) => (
                        <p key={idx} className="elec-design-hero-step-point">
                          <span className="elec-design-hero-arrow-icon">→</span> {point}
                        </p>
                      ))}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}

        <div
          style={{ height: `${timelineHeight}px` }}
          className="elec-design-hero-progress-bar-wrapper"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="elec-design-hero-progress-bar"
          />
        </div>
      </div>
    </div>
  );
};

const Testingcommissioning = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const timelineData = [
    {
      title: "Ensuring power systems relentlessly",
      image: image7,
      paragraph: {
        points: [
          "We offer full range of services for power systems reflecting real-world solutions turning any engineering recommendations through to full implementation involving the testing and commissioning activities. also we offer predictive maintenance, acceptance testing, repair and upgrade services to protect the critical electrical distribution systems of client's facility. With our portfolio covering from industrial plants to government power facilities thus our engineers are prepared to assist with keeping the facilities operating properly.",
        ],
      },
    },
    {
      title: "What we Test",
      image: image8,
      paragraph: {
        points: [
],
      },
    },
  ];

  return (
    <>
      <Header />
      <div className="elec-installation-page-container">
        <div className="elec-installation-page-header">
          <h1>Testing & Commissioning</h1>
          <p>
          Our Testing & Commissioning services ensure that all electrical systems and components operate safely, efficiently, and in full compliance with design specifications. From high-voltage systems and transformers to switchgear and protection relays, our expert engineers perform thorough testing protocols using advanced diagnostic tools. We verify system integrity, detect potential issues before failures occur, and optimize performance across the entire power network. Whether it's a new installation or periodic maintenance, our services deliver confidence in your electrical infrastructure’s reliability, safety, and readiness for operation.
          </p>
        </div>

        <div className="elec-installation-cube-wrapper">
          <div className="elec-installation-cube-gallery">
            <img src={image1} alt="Engineering Slide 1" />
            <img src={image2} alt="Engineering Slide 2" />
            <img src={image3} alt="Engineering Slide 3" />
            <img src={image4} alt="Engineering Slide 4" />
            <img src={image5} alt="Engineering Slide 5" />
            <img src={image6} alt="Engineering Slide 6" />
          </div>
        </div>

        <div className="elec-installation-silk-bg">
           <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>
      </div>

      <ElecDesignHeroSection data={timelineData} />

     {/* === 12 Unique Boxes Section === */}
{/* === 12 Unique Boxes Section === */}
<div className="test-commission-12box-section">
  <h2 className="test-commission-12box-title">Our Key Testing Capabilities</h2>
  <div className="test-commission-12box-grid">
    {[
      {
        title: "High Voltage Test",
        points: [
          "Insulation Resistance",
          "Sheath Test",
          "DC/VLF Hipot Test for HV cables",
          "AC Hipot Test for HV Switchgear"
        ]
      },
      {
        title: "Over Head Line Test",
        points: [
          "Insulation Resistance Test",
          "Phase Sequence Check",
          "Positive, Negative and Zero Sequence Impedance"
        ]
      },
      {
        title: "Earth Measurements",
        points: [
          "Grid Resistance Measurement",
          "Step and Touch Potential",
          "Earth Pit Resistance",
          "Soil Resistivity Test Measurement"
        ]
      },
      {
        title: "Motor Test",
        points: [
          "Insulation Resistance Test",
          "Full Voltage Test",
          "Load Test",
          "Motor Circuit Analysis"
        ]
      },
      {
        title: "Switchgear Test",
        points: [
          "Testing and Commissioning of High Voltage and Low Voltage Switchgear",
          "Maintenance and Trouble-shooting"
        ]
      },
      {
        title: "Annual Maintenance",
        points: [
          "Substations",
          "Process Plants"
        ]
      },
      {
        title: "Capacitor Bank Test",
        points: [
          "Capacitance Measurement",
          "Inductance Measurement",
          "High Voltage Test"
        ]
      },
      {
        title: "Power Quality Analyser Test",
        points: [
          "Measuring and Analysing the Power Quality of Electrical Equipment",
          "Harmonic Analysis"
        ]
      },
      {
        title: "Relay Test",
        points: [
          "Line Diff. Relay",
          "Transformer Diff. Relay",
          "Distance Relay",
          "Synchronization Check Relay",
          "Backup Protection Relays"
        ]
      },
      {
        title: "Power/ Distribution/ Auto Transformer/ Reactor",
        points: [
          "Electrical Tests",
          "Tan Delta & Capacitance Measurement",
          "SFRA Test",
          "Oil Sampling and Chemical Analysis"
        ]
      },
      {
        title: "CT/ VT Test",
        points: [
          "Insulation Resistance",
          "Polarity",
          "Excitation",
          "Winding Resistance",
          "Ratio Test"
        ]
      },
      {
        title: "Battery System Test",
        points: [
          "Functional checks on Charger Panel",
          "Load Test of Battery Charger",
          "Initial Check of Battery Cells",
          "Charging and Discharging Test for Battery Cells"
        ]
      }
    ].map((box, index) => (
      <div key={index} className="test-commission-box">
        <div className="test-commission-box-inner" data-aos="fade-up">
          <h3>{box.title}</h3>
          <ul>
            {box.points.map((point, idx) => (
              <li key={idx}> {point}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
</div>


      <Footer />
    </>
  );
};

export default Testingcommissioning;
